import axiosInstance from "../utils/axios"

export const vocationalInstitutionService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get('/vocational-institution/all')
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/vocational-institution',{ params })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/vocational-institution/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/vocational-institution', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/vocational-institution/${id}`, data);
    return response.data;
  },
  updateStatus: async (id, data) => {
    const response = await axiosInstance.put(`/vocational-institution/${id}/status`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/vocational-institution/${id}`)
    return response.data
  },
  exportExcel: async (params = {}) => {
    const response = await axiosInstance.get(
      "/vocational-institution/export-excel",
      {
        params,
        responseType: "blob",
      }
    );
    return response;
  },
}
